<template>
  <div>
    <el-card>
      <app-breadcrumb :items="items"></app-breadcrumb>
    </el-card>
    <br />
    <el-card>
      <h2 class="title">
        Notificaciones agrupadas
        <i
          class="custom__icon"
          :class="(opentableShowGroup ? 'icon-cerrar' : 'icon-ver_mas02')"
          @click="toggle('tableShowGroup')"
        ></i>
      </h2>
      <br />
      <h5 v-if="reloadComponent==0">
        <i class="el-icon-loading"></i> Espere a que termine de cargar los datos.
      </h5>
      <app-table-paginate
        v-if="reloadComponent!=0"
        :key="reloadComponent"
        v-show="tableShowGroup"
        routeDelete="no"
        selection="no"
        :tableQuery="getList"
        :tableColumns="tableColumns"
        :limit="limit"
        :search="false"
        :noDisplayActions="false"
        :expand="true"
        :expandData="'notifications'"
        :expandColumns="expandColumns"
        :previewModal="true"
        :displayAccionesExpandTable="true"
      ></app-table-paginate>
    </el-card>
    <br />

    <!--el-card>
      <h2 class="title">
        Notificaciones
        <i
          class="custom__icon"
          :class="(opentableShow ? 'icon-cerrar' : 'icon-ver_mas02')"
          @click="toggle('tableShow')"
        ></i>
      </h2>
      <br>
      <app-table-paginate
        v-show="tableShow"
        routeDelete="no"
        selection="no"
        :tableQuery="getListNotifications"
        :tableColumns="expandColumns"
        :limit="10000"
        :search="true"
        :noDisplayActions="true"
      ></app-table-paginate>
    </!--el-card>
    <br-->

    <el-card>
      <h2 class="title">
        Gráficas
        <i
          class="custom__icon"
          :class="(opentableShowChart ? 'icon-cerrar' : 'icon-ver_mas02')"
          @click="toggle('tableShowChart')"
        ></i>
      </h2>
      <el-row :gutter="24" v-show="tableShowChart">
        <el-col :span="24">
          <app-chart
            v-if="dataSource"
            type="dragcolumn2d"
            :width="width"
            :height="height"
            :dataFormat="dataFormat"
            :dataSource="dataSource"
          ></app-chart>
        </el-col>
      </el-row>
    </el-card>

    <app-modal-users v-if="showUsersModal" :id_notificacion="id_notificacion"></app-modal-users>
  </div>
</template>

<script>
import ApiService from "@/common/api.service";
import tablaConPaginador from "@/components/_commons/tablaConPaginador";
import breadcrumb from "@/components/_commons/breadcrumb";
import chart from "@/components/_commons/chart";
import modalUsers from "@/components/auditoria/modals/showUsersWithNotifications";
export default {
  name: "NotificacionesAgrupadas",
  components: {
    "app-table-paginate": tablaConPaginador,
    "app-breadcrumb": breadcrumb,
    "app-chart": chart,
    "app-modal-users": modalUsers
  },
  created() {
    this.get();

    this.$root.$on("TableModal", val => {
      this.id_notificacion = val;
      this.showUsersModal = true;
    });
    this.$root.$on("closeModal", () => {
      this.showUsersModal = false;
    });
  },
  beforeDestroy() {
    this.$root.$off("closeModal", () => {
      this.showUsersModal = false;
    });
    this.$root.$off("TableModal", val => {
      this.id_notificacion = val;
      this.showUsersModal = true;
    });
  },
  data() {
    return {
      id_notificacion: 0,
      showUsersModal: false,
      loader: 0,
      reloadComponent: 0,
      width: "100%",
      height: "400",
      dataFormat: "json",
      dataSource: {
        chart: {
          caption: "Agrupación de notificaciones por escritorio",
          yaxismaxvalue: this.max,
          theme: "fusion",
          plotToolText: "<b>$label</b><br>$seriesName: <b>$dataValue</b>"
        },
        categories: [
          {
            category: null
          }
        ],
        dataset: null
      },
      dataSource2: {
        chart: {
          bgColor: "FFFFFF",
          caption: "Notificaciones",
          plottooltext: "<b>$percentValue</b> de notificaciones $label ",
          showLegend: "1",
          showPercentValues: "1",
          legendPosition: "bottom",
          useDataPlotColorForLabels: "1",
          enableMultiSlicing: "0",
          theme: "fusion",
          showlegend: "0"
        },
        data: null
      },
      items: [
        {
          path: "/auditoria/",
          label: "auditoria"
        },
        {
          path: "/auditoria/notifications-agrupadas",
          label: "Histórico de accesos Todos los usuarios"
        }
      ],

      listAPI: false,
      loading: true,
      strMonths: [
        "Enero",
        "Febrero",
        "Marzo",
        "Abril",
        "Mayo",
        "Junio",
        "Julio",
        "Agosto",
        "Septiembre",
        "Octubre",
        "Noviembre",
        "Diciembre"
      ],
      tableColumns: [
        {
          prop: "desktop",
          label: "Tipo"
        },
        {
          prop: "permisos",
          label: "Permiso"
        }
      ],
      expandColumns: [
        {
          prop: "notification",
          label: "Notificación"
        },
        {
          prop: "leido",
          label: "Leída"
        },
        {
          prop: "compr",
          label: "Comprendido"
        },
        {
          prop: "fecha",
          label: "Fecha"
        },
        {
          prop: "perm",
          label: "Permiso"
        }
      ],
      searchQuery: "",
      deleterow: false,
      limit: 10,
      tableShow: true,
      opentableShowGroup: false,
      tableShowGroup: false,
      tableShow: false,
      opentableShow: false,
      notificationsAPI: false,
      opentableShowChart: false,
      tableShowChart: false,
      max: 0
    };
  },
  methods: {
    toggle(table) {
      this["open" + table] = !this["open" + table];
      this[table] = !this[table];
    },
    async get() {
      ApiService.post("auditoria/all-notifications", {
        token: localStorage.getItem("token")
      }).then(response => {
        let notificaciones = [];

        let leido = 0,
          noread = 0,
          comprendido = 0,
          nocomprendido = 0,
          categories = [],
          seriesLeidos = [
            {
              seriesname: "Leídos",
              data: []
            }
          ],
          seriesNoLeidos = [
            {
              seriesname: "Comprendidos",
              data: []
            }
          ];

        this.listAPI = response.data.filter(e => {
          return e.id != 8;
        });
        let contador = 0;
        this.listAPI.map(e => {
          contador++;
          if (e.id != 0) {
            categories.push({
              label: e.desktop
            });
          }
          let i = 0;
          leido = 0;
          comprendido = 0;
          e.notifications.map(r => {
            if (e.id != 0) {
              leido += parseInt(r.leido);
              comprendido += parseInt(r.compr);
            }
            i++;

            notificaciones.push(r);
          });
          i > this.max ? (this.max = i) : false;
          if (e.id != 0) {
            seriesLeidos[0].data.push({
              value: leido,
              alpha: "100"
            });
            seriesNoLeidos[0].data.push({
              value: parseInt(comprendido),
              alpha: "100"
            });
          }
          if (contador == this.listAPI.length) {
            this.reloadComponent++;
            this.toggle("tableShowGroup");
          }
        });
        this.notificationsAPI = notificaciones;
        this.dataSource.categories[0].category = categories;
        seriesLeidos.seriesname = "Leídos";
        seriesNoLeidos.seriesname = "Comprendido";
        this.dataSource.dataset = seriesLeidos.concat(seriesNoLeidos);

        this.dataSource2.data = [
          {
            label: "Leídas",
            value: leido,
            color: "#105b4a"
          },
          {
            label: "Comprendido",
            value: comprendido,
            color: "#fb4513"
          }
        ];
      });
    }
  },
  computed: {
    getListNotifications() {
      return this.notificationsAPI;
    },
    getList() {
      return this.listAPI;
    }
  }
};
</script>


<style lang="scss" scoped>
.el-breadcrumb {
  margin-bottom: 0 !important;
}
.title {
  display: flex;
  align-items: center;
  justify-content: space-between;
}
</style>



// WEBPACK FOOTER //
// src/components/auditoria/userNotificactionsAgrupadas.vue